var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoldCompetition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_170414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.96521 2.37715C7.89462 2.25949 7.76747 2.1875 7.63026 2.1875H3.85384C3.55021 2.1875 3.36267 2.51874 3.51888 2.7791L7.73763 9.81035C7.80823 9.92801 7.93538 10 8.07259 10H11.849C12.1526 10 12.3402 9.66876 12.184 9.4084L7.96521 2.37715Z",
    fill: "#C52229"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.63161 1.79688H3.85519C3.24793 1.79688 2.87284 2.45935 3.18528 2.98007L7.40403 10.0113C7.54522 10.2466 7.79952 10.3906 8.07394 10.3906H11.8504C12.4576 10.3906 12.8327 9.72815 12.5203 9.20743L8.30152 2.17618C8.16033 1.94086 7.90603 1.79688 7.63161 1.79688ZM7.63161 2.1875C7.76882 2.1875 7.89597 2.25949 7.96656 2.37715L12.1853 9.4084C12.3415 9.66876 12.154 10 11.8504 10H8.07394C7.93673 10 7.80958 9.92801 7.73898 9.81035L3.52023 2.7791C3.36402 2.51874 3.55156 2.1875 3.85519 2.1875H7.63161Z",
    fill: "#9B0F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0348 2.37715C12.1054 2.25949 12.2325 2.1875 12.3697 2.1875H16.1462C16.4498 2.1875 16.6373 2.51874 16.4811 2.7791L12.2624 9.81035C12.1918 9.92801 12.0646 10 11.9274 10H8.15099C7.84736 10 7.65982 9.66876 7.81604 9.4084L12.0348 2.37715Z",
    fill: "#F1333B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3703 1.79688H16.1468C16.754 1.79688 17.1291 2.45935 16.8167 2.98007L12.5979 10.0113C12.4567 10.2466 12.2024 10.3906 11.928 10.3906H8.1516C7.54434 10.3906 7.16925 9.72815 7.48168 9.20743L11.7004 2.17618C11.8416 1.94086 12.0959 1.79688 12.3703 1.79688ZM12.3703 2.1875C12.2331 2.1875 12.106 2.25949 12.0354 2.37715L7.81664 9.4084C7.66042 9.66876 7.84797 10 8.1516 10H11.928C12.0652 10 12.1924 9.92801 12.263 9.81035L16.4817 2.7791C16.6379 2.51874 16.4504 2.1875 16.1468 2.1875H12.3703Z",
    fill: "#9B0F15"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4419 2.40925C12.5351 2.46342 12.5669 2.58295 12.5127 2.67623L10.7549 5.70357C10.7007 5.79686 10.5812 5.82857 10.4879 5.7744C10.3946 5.72024 10.3629 5.60071 10.4171 5.50743L12.1749 2.48008C12.229 2.3868 12.3486 2.35509 12.4419 2.40925Z",
    fill: "#FE666D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.84721 2.40925C3.75392 2.46342 3.72221 2.58295 3.77638 2.67623L5.53419 5.70357C5.58835 5.79686 5.70788 5.82857 5.80117 5.7744C5.89445 5.72024 5.92616 5.60071 5.872 5.50743L4.11418 2.48008C4.06002 2.3868 3.94049 2.35509 3.84721 2.40925Z",
    fill: "#DF3840"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.56055 2.82837C7.56055 2.96658 7.45124 3.07861 7.31641 3.07861C7.18157 3.07861 7.07227 2.96658 7.07227 2.82837C7.07227 2.69016 7.18157 2.57812 7.31641 2.57812C7.45124 2.57812 7.56055 2.69016 7.56055 2.82837Z",
    fill: "#AA161D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.70308 2.8894C6.70308 3.06132 6.56711 3.20068 6.39939 3.20068C6.23167 3.20068 6.0957 3.06132 6.0957 2.8894C6.0957 2.71749 6.23167 2.57812 6.39939 2.57812C6.56711 2.57812 6.70308 2.71749 6.70308 2.8894Z",
    fill: "#AA161D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.46089 3.78003C7.46089 3.95194 7.32492 4.09131 7.1572 4.09131C6.98948 4.09131 6.85352 3.95194 6.85352 3.78003C6.85352 3.60811 6.98948 3.46875 7.1572 3.46875C7.32492 3.46875 7.46089 3.60811 7.46089 3.78003Z",
    fill: "#AA161D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1572 3.35583C8.1572 3.44179 8.08922 3.51147 8.00536 3.51147C7.9215 3.51147 7.85352 3.44179 7.85352 3.35583C7.85352 3.26988 7.9215 3.2002 8.00536 3.2002C8.08922 3.2002 8.1572 3.26988 8.1572 3.35583Z",
    fill: "#AA161D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54978 3.62439C6.54978 3.71035 6.4818 3.78003 6.39794 3.78003C6.31408 3.78003 6.24609 3.71035 6.24609 3.62439C6.24609 3.53843 6.31408 3.46875 6.39794 3.46875C6.4818 3.46875 6.54978 3.53843 6.54978 3.62439Z",
    fill: "#AA161D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.70408 2.67224C5.70408 2.7582 5.6361 2.82788 5.55223 2.82788C5.46837 2.82788 5.40039 2.7582 5.40039 2.67224C5.40039 2.58628 5.46837 2.5166 5.55223 2.5166C5.6361 2.5166 5.70408 2.58628 5.70408 2.67224Z",
    fill: "#AA161D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00291 4.44275C8.00291 4.52871 7.93492 4.59839 7.85106 4.59839C7.7672 4.59839 7.69922 4.52871 7.69922 4.44275C7.69922 4.35679 7.7672 4.28711 7.85106 4.28711C7.93492 4.28711 8.00291 4.35679 8.00291 4.44275Z",
    fill: "#AA161D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.22166 4.59802C7.22166 4.68398 7.15367 4.75366 7.06981 4.75366C6.98595 4.75366 6.91797 4.68398 6.91797 4.59802C6.91797 4.51207 6.98595 4.44238 7.06981 4.44238C7.15367 4.44238 7.22166 4.51207 7.22166 4.59802Z",
    fill: "#AA161D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.73838 4.03357C8.73838 4.17346 8.62774 4.28687 8.49126 4.28687C8.35478 4.28687 8.24414 4.17346 8.24414 4.03357C8.24414 3.89368 8.35478 3.78027 8.49126 3.78027C8.62774 3.78027 8.73838 3.89368 8.73838 4.03357Z",
    fill: "#AA161D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.05955 4.7533C9.05955 4.83925 8.99156 4.90894 8.9077 4.90894C8.82384 4.90894 8.75586 4.83925 8.75586 4.7533C8.75586 4.66734 8.82384 4.59766 8.9077 4.59766C8.99156 4.59766 9.05955 4.66734 9.05955 4.7533Z",
    fill: "#AA161D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2734 12.5391C15.2734 15.4515 12.9124 17.8125 10 17.8125C7.08756 17.8125 4.72656 15.4515 4.72656 12.5391C4.72656 9.62662 7.08756 7.26562 10 7.26562C12.9124 7.26562 15.2734 9.62662 15.2734 12.5391Z",
    fill: "#FFBB0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6641 12.5391C15.6641 15.6672 13.1282 18.2031 10 18.2031C6.87182 18.2031 4.33594 15.6672 4.33594 12.5391C4.33594 9.41089 6.87182 6.875 10 6.875C13.1282 6.875 15.6641 9.41089 15.6641 12.5391ZM10 17.8125C12.9124 17.8125 15.2734 15.4515 15.2734 12.5391C15.2734 9.62662 12.9124 7.26562 10 7.26562C7.08756 7.26562 4.72656 9.62662 4.72656 12.5391C4.72656 15.4515 7.08756 17.8125 10 17.8125Z",
    fill: "#E89B05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.11719 12.7344C5.00932 12.7344 4.92188 12.6469 4.92188 12.5391C4.92188 9.73449 7.19543 7.46094 10 7.46094C10.1079 7.46094 10.1953 7.54838 10.1953 7.65625C10.1953 7.76412 10.1079 7.85156 10 7.85156C7.41117 7.85156 5.3125 9.95023 5.3125 12.5391C5.3125 12.6469 5.22506 12.7344 5.11719 12.7344Z",
    fill: "#E8AA0A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8828 12.3438C14.9907 12.3438 15.0781 12.4312 15.0781 12.5391C15.0781 15.3436 12.8046 17.6172 10 17.6172C9.89213 17.6172 9.80469 17.5297 9.80469 17.4219C9.80469 17.314 9.89213 17.2266 10 17.2266C12.5888 17.2266 14.6875 15.1279 14.6875 12.5391C14.6875 12.4312 14.7749 12.3438 14.8828 12.3438Z",
    fill: "#E8AA0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9062 12.5391C13.9062 14.6964 12.1574 16.4453 10 16.4453C7.84264 16.4453 6.09375 14.6964 6.09375 12.5391C6.09375 10.3817 7.84264 8.63281 10 8.63281C12.1574 8.63281 13.9062 10.3817 13.9062 12.5391Z",
    fill: "#FFDD28"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2969 12.5391C14.2969 14.9122 12.3731 16.8359 10 16.8359C7.6269 16.8359 5.70312 14.9122 5.70312 12.5391C5.70312 10.166 7.6269 8.24219 10 8.24219C12.3731 8.24219 14.2969 10.166 14.2969 12.5391ZM10 16.4453C12.1574 16.4453 13.9062 14.6964 13.9062 12.5391C13.9062 10.3817 12.1574 8.63281 10 8.63281C7.84264 8.63281 6.09375 10.3817 6.09375 12.5391C6.09375 14.6964 7.84264 16.4453 10 16.4453Z",
    fill: "#E89B05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 15.8594C11.8338 15.8594 13.3203 14.3728 13.3203 12.5391C13.3203 12.4312 13.4078 12.3437 13.5156 12.3437C13.6235 12.3437 13.7109 12.4312 13.7109 12.5391C13.7109 14.5886 12.0495 16.25 10 16.25C9.89213 16.25 9.80469 16.1626 9.80469 16.0547C9.80469 15.9468 9.89213 15.8594 10 15.8594Z",
    fill: "#ECC704"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.21875C8.16624 9.21875 6.67969 10.7053 6.67969 12.5391C6.67969 12.6469 6.59224 12.7344 6.48438 12.7344C6.37651 12.7344 6.28906 12.6469 6.28906 12.5391C6.28906 10.4896 7.95051 8.82812 10 8.82812C10.1079 8.82812 10.1953 8.91557 10.1953 9.02344C10.1953 9.13131 10.1079 9.21875 10 9.21875Z",
    fill: "#FFEF9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4667 14.1017H9.80527V11.552L9.01562 11.7969V11.259L10.3958 10.7646H10.4667V14.1017Z",
    fill: "#FFEF9C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8574 14.1017C10.8574 14.3175 10.6825 14.4924 10.4667 14.4924H9.80527C9.58953 14.4924 9.41464 14.3175 9.41464 14.1017V12.0821L9.13134 12.17C9.01279 12.2068 8.88383 12.185 8.78391 12.1114C8.68398 12.0378 8.625 11.921 8.625 11.7969V11.259C8.625 11.0941 8.72861 10.9469 8.8839 10.8913L10.2641 10.3969C10.3063 10.3818 10.3509 10.374 10.3958 10.374H10.4667C10.6825 10.374 10.8574 10.5489 10.8574 10.7646V14.1017ZM9.80527 11.552V14.1017H10.4667V10.7646H10.3958L9.01562 11.259V11.7969L9.80527 11.552Z",
    fill: "#E89B05"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_170414",
    x: 0.625,
    y: 0.625,
    width: 19.4419,
    height: 19.4419,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.691877,
    dy: 0.691877
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.637788 0 0 0 0 0.545996 0 0 0 0 0.47948 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_170414"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_170414",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldCompetition);
export default __webpack_public_path__ + "static/media/GoldCompetition.3fc4e5d9d3d53b548b2740bf717cf819.svg";
export { ForwardRef as ReactComponent };